import {formatDate} from '@angular/common';
import { Component, OnInit, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';;
import { UtilService } from 'src/app/services/util.service';
import { STORAGE_LAST_RESTAURANT } from 'src/environments/environment'

import { PushService, TOPIC_RESTAURANT_IS_OPENING, TOPIC_RESTAURANT_REMIND_OPENING, TOPIC_NEW_ORDER, TOPIC_NEW_CONTACT_MESSAGE } from 'src/app/services/push.service';
import { ImageService } from 'src/app/services/image.service';
import { WifiService } from 'src/app/services/wifi.service';
import { OrderService } from 'src/app/services/order.service';
import { STORAGE_REMIND_OPEN_RESTAURANT, STORAGE_INFORM_ABOUT_ORDER_VIA_PUSH, fcmUrl } from 'src/environments/constant';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { Restaurant } from 'src/app/models/restaurant.model';
import { AlertService } from '../../../services/alert.service';
import { RestaurantService } from 'src/app/services/restaurant.service';
import { CoronaService } from 'src/app/pages/shared/corona/corona.service';

//declare var google;

@Component({
  selector: 'app-owner-home',
  templateUrl: './owner-home.page.html',
  styleUrls: ['./owner-home.page.scss'],
})
export class OwnerHomePage implements OnInit {

  @ViewChild('map', { static: false }) mapElement: ElementRef;
  map: any;

  constructor(private router: Router, public db: DBService, public imageService: ImageService,
    public util: UtilService, private pushService: PushService, private wifiService: WifiService,
    private orderService: OrderService, private alert: AlertService, private ngZone: NgZone, private insomnia: Insomnia,
    public restaurantService: RestaurantService, private coronaService: CoronaService) {

    this.util.info('Konstruktor OwnerHomePage')
  }

  ngOnInit() {
    this.util.info('ngOnInit1 OwnerHomePage')
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
    this.util.info('ngOnInit2 OwnerHomePage')

    this.insomnia.allowSleepAgain()
      .then(
      () => console.log('success'),
      (e) => console.log('error', e)
      );

    //Check, if a reminder should be in place
    let val = localStorage.getItem(STORAGE_REMIND_OPEN_RESTAURANT + "-" + this.db.currentRestaurantKey)
    if (val) {
      this.util.remindToOpenRestaurantPersonally = true
      this.pushService.subscribeToTopic(TOPIC_RESTAURANT_REMIND_OPENING, this.db.currentRestaurantKey)
    } else {
      this.util.remindToOpenRestaurantPersonally = false
      this.pushService.unsubscribeToTopic(TOPIC_RESTAURANT_REMIND_OPENING, this.db.currentRestaurantKey)
    }

    //Check, if a reminder should be in place
    val = localStorage.getItem(STORAGE_INFORM_ABOUT_ORDER_VIA_PUSH + "-" + this.db.currentRestaurantKey)
    if (val) {
      this.util.informAboutOrdersViaPush = true
      this.pushService.subscribeToTopic(TOPIC_NEW_ORDER, this.db.currentRestaurantKey)
    } else {
      this.util.informAboutOrdersViaPush = false
      this.pushService.unsubscribeToTopic(TOPIC_NEW_ORDER, this.db.currentRestaurantKey)
    }

    this.orderService.initRouter(this.router)

    //Damit man beim Oeffnen der App wieder im gleichen Restaurant ist
    localStorage.setItem(STORAGE_LAST_RESTAURANT, JSON.stringify(this.db.currentRestaurantKey))

    //this.events.publish('resetItems')
    this.db.setPage('home')

    this.wifiService.networks = []
    // this.wifiService.initStartWifiScreening();  //nicht zu oft ausfuehren

    if (this.util.targetParam) {
      if (this.util.targetParam == "calendar"){
        this.openCalendar();
      }
      this.util.targetParam = undefined
    }

  }

  get hasItems(): boolean {
    const myNode = document.getElementById("aufgabenliste");
    return myNode && myNode.childElementCount > 1
  }

  setVisibleForCustomer() {
    this.db.currentRestaurant.isActive = true
    this.save()
  }

  send4MamingoCheck(restaurant: Restaurant) {
    if (!restaurant) {
      this.util.presentToast("Entschuldigung, da hat etwas nicht funktioniert (Code 0X95).", 4000, 'toast-warning')
      return
    }

    let message: string = "Restaurant-ID: " + restaurant.id + " / Restaurant-Name: " + restaurant.name
    this.pushService.sendPush("Restaurant zur Prüfung von " + (this.db.loggedUserUID ? this.db.loggedUserUID : 'Unbekannt'), message, TOPIC_NEW_CONTACT_MESSAGE, 'BARELA_CHCK_RESTAURANT').subscribe((val: any) => {
      this.db.restaurants[restaurant.id].isApprovedByMamingo = 0;
      this.db.sendMessage(new Date().toLocaleString() + ": Prüfung - " + message + " (Von: " + (this.db.loggedUserUID ? this.db.loggedUserUID : 'Unbekannt') + ")")
      this.util.presentToast('Vielen Dank. Wir prüfen dein Restaurant umgehend. Du solltest innerhalb 24h eine Rückmeldung von uns per Mail erhalten.', 9000, 'toast-success')
      this.save()
    }, err => {
      this.util.presentToast("Entschuldigung, da hat etwas nicht funktioniert (Code 0X91).", 4000, 'toast-warning')
      this.util.error("err sendMessage", JSON.stringify(err))
    })
  }

  selectWifiTab() {
    if (this.util.demo || (this.util.isMobileApp2 && !this.util.isIOS())) {
      this.db.setPage('wifi')
      this.wifiService.enableWifi(false);
      this.orderService.askOwner4RealPermissions()
    } else {
      this.util.presentToast('WLANs können nur in einem Android Device geändert werden.')
    }
  }

  isValidDate(d) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      
      if (isNaN(d.getTime())) {  // d.valueOf() could also work
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  createReport() {
    let inputs = []
    let dateFrom = formatDate(new Date(), 'yyyy-MM-dd', 'de-DE')
    let dateTo = formatDate(new Date(), 'yyyy-MM-dd', 'de-DE')
    inputs.push({ name: 'dateFrom', type: 'date', id: 'dateFrom', value: dateFrom, placeholder: `z.B. ${dateFrom}` })
    inputs.push({ name: 'dateTo', type: 'date', id: 'dateTo', value: dateTo, placeholder: `z.B. ${dateTo}` })
    this.alert.presentMultipleAlertPrompt(this, (ref, data) => {
      let d1 = new Date(data.dateFrom + " " + "00:00:00")
      let d2 = new Date(data.dateTo + " " + "23:59:59")
      
      if(!this.isValidDate(d1)){
        d1 = new Date(data.dateFrom + "T" + "00:00:00")
        d2 = new Date(data.dateTo + "T" + "23:59:59")
        if(d1.getTime()>d2.getTime()) d2 = new Date(data.dateFrom + "T" + "23:59:59")
      }else{
        if(d1.getTime()>d2.getTime()) d2 = new Date(data.dateFrom + " " + "23:59:59")
      }
      
      if (this.db.currentRestaurant.options && this.db.currentRestaurant.options.pdfExtend){
        window.open(`${fcmUrl}/pdf-extend/${this.db.currentRestaurantKey}/${this.db.currentRestaurant.name}/${d1.getTime()}/${d2.getTime()}`)        
      }else{
        window.open(`${fcmUrl}/pdf/${this.db.currentRestaurantKey}/${this.db.currentRestaurant.name}/${d1.getTime()}/${d2.getTime()}`)        
      }
    }, inputs, 'Zeitraum des Reports', 'Bitte gib ein Anfangs- und Enddatum ein.', "", "", "Abbrechen", "Herunterladen")
  }

  getAvailableNetworks() {
    let ssids: string[] = []
    let networks: any[] = []

    if (!this.wifiService.networks) return []
    for (let network of this.wifiService.networks) {
      console.error(network)
      if (ssids.indexOf(network.SSID) === -1) {
        ssids.push(network.SSID) //verhindern, dass doppelte rein kommen (TODO: Achten auf Connect Possibilities)
        networks.push(network)
      }
    }
    return networks;
  }

  //Oeffnet Speisekarte
  openOrdering() {
    this.ngZone.run(() => this.router.navigate(['/menu']))
  }

  //Oeffnet Kuechenmonitor
  openKuechenmonitor() {
    this.ngZone.run(() => this.router.navigate(['/order']))
  }

  openEditSpecial() {
    this.ngZone.run(() => this.router.navigate(['/edit-special']))
  }

  openEditTable() {
    this.ngZone.run(() => this.router.navigate(['/edit-table']))
  }

  openOpeningTimes() {
    this.ngZone.run(() => this.router.navigate(['/opening-time']))
  }

  openCalendar() {
    this.ngZone.run(() => this.router.navigate(['/calendar']))
  }
  
  openBonuskarten() {
    this.ngZone.run(() => this.router.navigate(['/bonsukarte-owner']))
  }

  openLocalInfo() {
    this.ngZone.run(() => this.router.navigate(['/local-info']))
  }

  openReservation() {
    this.ngZone.run(() => this.router.navigate(['/reservation-owner']))
  }

  openEditDeliveryArea() {
    this.ngZone.run(() => this.router.navigate(['/edit-delivery-area']))
  }

  openCorona(){
    this.coronaService.selectRestaurant()
    this.ngZone.run(() => this.router.navigate(['/corona']))    
  }

  save() {
    this.db.currentPage = 'home'
    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.db.updateMenu(this.db.currentMenuKey)
    this.util.presentToast("Angaben wurden gespeichert")
  }

  setPage(componentName: string) {
    this.ngZone.run(() => this.db.setPage(componentName))
  }


  /**
   * Back Button in footer
   * @param currentPage 
   */
  back(currentPage: string) {
    this.util.log("aktuelle seite in back()", currentPage)
    switch (currentPage) {
      case 'home':
        localStorage.removeItem(STORAGE_LAST_RESTAURANT)
        this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
        break;
      case 'map':
      case 'info':
      case 'employees':
      case 'wifi':
      case 'order':
        this.db.setPage('home')
        break;
      case 'basket':
        this.db.setPage('home')
        break;
      default:
        localStorage.removeItem(STORAGE_LAST_RESTAURANT)
        this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
    }
  }
  
  selectPaypalMail(){
    this.alert.presentAlertPrompt(null, (ref, data) => {
      this.db.currentRestaurant.paypal = data.input
      this.db.updateRestaurant(this.db.currentRestaurantKey)
      this.util.presentToast("Paypal Adresse wurde gespeichert. Unter 'Einstellungen' kann diese Angabe geändert werden.")
    }, "Deine Paypal Adresse", "", "", "Deine Paypal Adresse wird für die Sofort-Bezahlung bei Abholung / Lieferung benötigt.", "Abbrechen", "Speichern")
  }

  selectWifi2(network) {
    let index = this.isWifiChecked(network)
    if (index === -1) {
      let newWifi = { ssid: network.SSID, bssid: network.BSSID, password: '', capabilities: network.capabilities }
      this.db.currentRestaurant.wifi2.push(newWifi)
    } else {
      this.db.currentRestaurant.wifi2.splice(index, 1);
    }

    this.db.updateRestaurant(this.db.currentRestaurantKey)
    //this.db.setPage("home")
  }

  isWifiChecked(network: any): number {
    for (let index in this.db.currentRestaurant.wifi2) {
      if (this.db.currentRestaurant.wifi2[index].ssid === network.SSID) {
        return +index
      }
    }

    return -1
  }

  //***** */
  isMyWifiSelected(myWifi: any): number {
    let availableNetworks: any[] = this.getAvailableNetworks();
    for (let networkIndex in availableNetworks) {
      if (myWifi.ssid === availableNetworks[networkIndex].SSID) {
        return +networkIndex;
      }
    }

    return -1;
  }

  getAvailableButNotActivNetworks(): any[] {
    let availableNetworks: any[] = this.getAvailableNetworks();
    let availableNetworksButNotActive: any[] = []
    let found: boolean = false

    for (let networkIndex in availableNetworks) {
      found = false;
      for (let myWifi of this.db.currentRestaurant.wifi2) {
        if (myWifi.ssid === availableNetworks[networkIndex].SSID) {
          found = true
          break
        }
      }
      if (!found) {
        availableNetworksButNotActive.push(availableNetworks[networkIndex])
      }
    }

    return availableNetworksButNotActive
  }
  //***** */

  deactivateNotListed(myWifi: any) {
    let index: number = -1
    for (let i in this.db.currentRestaurant.wifi2) {
      if (this.db.currentRestaurant.wifi2[i].ssid === myWifi.ssid) {
        index = +i
        break;
      }
    }
    if (index > -1) {
      this.db.currentRestaurant.wifi2.splice(index, 1);
      this.db.updateRestaurant(this.db.currentRestaurantKey)
    }
  }

}
